import React from 'react';
import {
  Grid,
} from '@mui/material';
import {makeStyles} from "@mui/styles";
import { Link } from 'react-router-dom';

import {
  colorPrimary,
  Body,
} from '../index';

const useStyles = makeStyles(() => ({
  subTitle: {
    fontSize: 14,
  },
  total: {
    fontSize: 14,
    fontWeight: 'bold',
    '& a:-webkit-any-link' : {
      textDecoration: 'none',
    }
  },
  number: {
    color: colorPrimary,
  },
}));

export default function TodayOrder (props: any) {
  const classes = useStyles();
  const { todayOrderCount } = props

  return (
    <Grid container direction={'row'} justifyContent={'space-between'}>
      <Grid item>
        <Body className={classes.total}>오늘 운송</Body>
      </Grid>
      <Grid item>
        <Body className={classes.total}>
          <Link to={'/app/freight/inquiry'}>
            <span className={classes.number}>{todayOrderCount}</span>
          </Link>건
        </Body>
      </Grid>
    </Grid>
  )
}